import * as types from './_actionTypes';

export const fetchQuizTemplatesRequest = () => ({
  type: types.FETCH_QUIZ_TEMPLATES_REQUEST
});

export const fetchQuizTemplatesSuccess = (templates) => ({
  type: types.FETCH_QUIZ_TEMPLATES_SUCCESS,
  payload: templates
});

export const fetchQuizTemplatesFailure = (error) => ({
  type: types.FETCH_QUIZ_TEMPLATES_FAILURE,
  payload: error
});

export const createQuizRequest = (quizData) => ({
  type: types.CREATE_QUIZ_REQUEST,
  payload: quizData
});

export const createQuizSuccess = (quiz) => ({
  type: types.CREATE_QUIZ_SUCCESS,
  payload: quiz
});

export const createQuizFailure = (error) => ({
  type: types.CREATE_QUIZ_FAILURE,
  payload: error
});

export const updateQuizRequest = (quizId, quizData) => ({
  type: types.UPDATE_QUIZ_REQUEST,
  payload: { quizId, quizData }
});

export const updateQuizSuccess = (quiz) => ({
  type: types.UPDATE_QUIZ_SUCCESS,
  payload: quiz
});

export const updateQuizFailure = (error) => ({
  type: types.UPDATE_QUIZ_FAILURE,
  payload: error
});

export const deleteQuizRequest = (quizId) => ({
  type: types.DELETE_QUIZ_REQUEST,
  payload: quizId
});

export const deleteQuizSuccess = (quizId) => ({
  type: types.DELETE_QUIZ_SUCCESS,
  payload: quizId
});

export const deleteQuizFailure = (error) => ({
  type: types.DELETE_QUIZ_FAILURE,
  payload: error
});

export const fetchMyQuizzesRequest = () => ({
  type: types.FETCH_MY_QUIZZES_REQUEST
});

export const fetchMyQuizzesSuccess = (quizzes) => ({
  type: types.FETCH_MY_QUIZZES_SUCCESS,
  payload: quizzes
});

export const fetchMyQuizzesFailure = (error) => ({
  type: types.FETCH_MY_QUIZZES_FAILURE,
  payload: error
});